import { createAsyncThunk } from '@reduxjs/toolkit';
import campaignApi from '~/apis/campaign';
import {
  CREATE_CAMPAIGN,
  DELETE_CAMPAIGN,
  GET_DETAIL_CAMPAIGN,
  GET_LIST_CAMPAIGN,
  UPDATE_CAMPAIGN,
} from '~/utils/constants/actionType';
import { IFormCampaign, IQueryParamCampaign, IQueryUpdateCampaign } from '~/utils/interface/campaign';

export const getListCampaign = createAsyncThunk(
  GET_LIST_CAMPAIGN,
  async (params: IQueryParamCampaign, { rejectWithValue }) => {
    try {
      const resp = await campaignApi.getListCampaign(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCampaign = createAsyncThunk(
  DELETE_CAMPAIGN,
  async (campaignId: string, { rejectWithValue }) => {
    try {
      const resp = await campaignApi.deleteCampaign(campaignId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCampaign = createAsyncThunk(
  CREATE_CAMPAIGN,
  async (body: IFormCampaign, { rejectWithValue }) => {
    try {
      const resp = await campaignApi.createCampaign(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailCampaign = createAsyncThunk(
  GET_DETAIL_CAMPAIGN,
  async (campaignId: string, { rejectWithValue }) => {
    try {
      const resp = await campaignApi.getDetailCampaign(campaignId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCampaign = createAsyncThunk(
  UPDATE_CAMPAIGN,
  async (payload: IQueryUpdateCampaign, { rejectWithValue }) => {
    try {
      const resp = await campaignApi.updateCampaign(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
